// extracted by mini-css-extract-plugin
module.exports = {"toasts":"Toasts_toasts__1yyi0","messageWrapper":"Toasts_messageWrapper__3_jus","messageContainer":"Toasts_messageContainer__2EJsM","close":"Toasts_close__2SdrF"};